import React from 'react';

import { Text } from '@components/TextGroups';

import { ToastLabel, ToastMessageContainer } from './styles';

interface ToastMessageProps {
  title: string;
  paragraph: string;
}

/**
 * ToastMessage component
 */

export const ToastMessage = ({ title, paragraph }: ToastMessageProps) => (
  <ToastMessageContainer>
    <ToastLabel>{title}</ToastLabel>
    <Text>
      {paragraph}
    </Text>
  </ToastMessageContainer>
);
